export default __webpack_public_path__ + "e9a4470aa50ec2730f27eae4fcc22344.jpg";